import { Clipboard } from '@angular/cdk/clipboard';
import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { IHasIdAndName } from '../../interfaces/has-id-and-name.interface';
import { AsyncJobService } from '../../services/async-job.service';
import { CopySiteService } from '../../services/copy-site.service';
import { ImportDataService } from '../../services/import-data.service';
import { CurrentSiteService } from '../../services/current-site.service';
import { ImportStructureInstancesDialog } from '../import-structure/import-structure.dialog';

@Component({
    selector: 'app-import-form-instances',
    templateUrl: '../import-structure/import-structure.dialog.html', //'./import-form-instances.dialog.html',
    styleUrls: [
        '../async-job-base/async-job-base.dialog.scss',
        '../import-structure/import-structure.dialog.scss',
        './import-form-instances.dialog.scss'
    ],
    standalone: false
})
export class ImportFormInstancesDialog extends ImportStructureInstancesDialog {
    // Properties.
    // None at this time.

    // Constructor.
    public constructor(public dialogRef: MatDialogRef<ImportStructureInstancesDialog>,
        @Inject(MAT_DIALOG_DATA) public targetObjectForBaseClass: IHasIdAndName,
        public dialog: MatDialog,
        //private copySiteServiceForBaseClass: CopySiteService, // We will want to remove this property.
        private importDataServiceForBaseClass: ImportDataService,
        private injectedAsyncJobServiceForBaseClass: AsyncJobService,
        private currentSiteServiceForBaseClass: CurrentSiteService,
        //private scheduledEventService: ScheduledEventService,
        private clipboardForBaseClass: Clipboard) {
        super(dialogRef,
            targetObjectForBaseClass,
            dialog,
            clipboardForBaseClass,
            //copySiteServiceForBaseClass,
            importDataServiceForBaseClass,
            injectedAsyncJobServiceForBaseClass,
            currentSiteServiceForBaseClass);
    }

    // Override base class methods.
    public AllowMultipleFiles(): boolean {
        return (true);
    }

    public startStructureImport(): void {
        // Initiate the import.
        let arrFiles: File[] = Array.from(this.fileSet);

        if (arrFiles.length > 0) {
            this.importDataService.importFormInstanceFiles(arrFiles, this.targetFolder.id).then(asyncJob => {
                // Save the returned job key. 
                this.startMonitoringJob(asyncJob, this.jobCompletedOrUpdatedArrowFunction, this.jobCompletedOrUpdatedArrowFunction);
            });
        }
    }
}
